import { render, staticRenderFns } from "./Swipe.vue?vue&type=template&id=52ee174a&scoped=true&"
import script from "./Swipe.vue?vue&type=script&lang=js&"
export * from "./Swipe.vue?vue&type=script&lang=js&"
import style0 from "./Swipe.vue?vue&type=style&index=0&id=52ee174a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee174a",
  null
  
)

export default component.exports